/* ============================================================
   NEXT FORM — main.js  v4.0
   All bugs fixed. Full Shopify integration.
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // GSAP plugin registration — MUST be first
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const NF = window.NF || {};
  const settings = NF.settings || {};

  // Reduced motion check
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // =========================================================
  // ANNOUNCEMENT BAR DISMISS
  // =========================================================
  const announcementBar = $('#announcement-bar');
  const announcementClose = $('#announcement-close');
  if (announcementBar) {
    if (sessionStorage.getItem('nf_announcement_dismissed')) {
      announcementBar.style.display = 'none';
    }
    if (announcementClose) {
      announcementClose.addEventListener('click', () => {
        announcementBar.style.display = 'none';
        sessionStorage.setItem('nf_announcement_dismissed', '1');
      });
    }
  }

  // =========================================================
  // SCROLL PROGRESS BAR
  // =========================================================
  const progressBar = $('#scroll-progress-bar');
  if (progressBar) {
    const updateProgress = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      progressBar.style.width = docHeight > 0 ? `${(scrollTop / docHeight) * 100}%` : '0%';
    };
    window.addEventListener('scroll', updateProgress, { passive: true });
  }

  // =========================================================
  // CUSTOM CURSOR — gated behind pointer:fine + settings
  // =========================================================
  if (!prefersReducedMotion && settings.enableCursor && window.matchMedia('(pointer: fine)').matches) {
    const cursor = $('#custom-cursor');
    const follower = $('#custom-cursor-follower');
    if (cursor && follower) {
      let mouseX = -200, mouseY = -200, followerX = -200, followerY = -200;
      document.addEventListener('mousemove', (e) => {
        mouseX = e.clientX; mouseY = e.clientY;
        cursor.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0) translate(-50%, -50%)`;
      });
      (function animateFollower() {
        followerX += (mouseX - followerX) * 0.13;
        followerY += (mouseY - followerY) * 0.13;
        follower.style.transform = `translate3d(${followerX}px, ${followerY}px, 0) translate(-50%, -50%)`;
        requestAnimationFrame(animateFollower);
      })();
      function setCursorHovered(state) {
        cursor.classList.toggle('hovered', state);
        follower.classList.toggle('hovered', state);
      }
      function attachCursorHover(el) {
        el.addEventListener('mouseenter', () => setCursorHovered(true));
        el.addEventListener('mouseleave', () => setCursorHovered(false));
      }
      $$('a, button, .card, .tilted-card-figure, .dock-item, input, select, textarea').forEach(attachCursorHover);
    }
  }

  // =========================================================
  // AURORA PARALLAX — gated
  // =========================================================
  if (!prefersReducedMotion && settings.enableAurora) {
    const bgAurora = $('#bg-aurora');
    if (bgAurora) {
      document.addEventListener('mousemove', (e) => {
        const xPct = (e.clientX / window.innerWidth - 0.5) * 22;
        const yPct = (e.clientY / window.innerHeight - 0.5) * 14;
        bgAurora.style.transform = `translate(${xPct}px, ${yPct}px)`;
      }, { passive: true });
    }
  }

  // =========================================================
  // INTERSECTION OBSERVER — FADE IN / SCALE IN
  // =========================================================
  const revealObserver = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        obs.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  $$('.fade-in, .fade-left, .fade-right, .scale-in').forEach(el => revealObserver.observe(el));

  // =========================================================
  // BLUR TEXT REVEAL
  // =========================================================
  function initBlurTextReveal() {
    $$('.blur-reveal-target').forEach(el => {
      const words = el.innerText.split(' ');
      el.innerHTML = '';
      words.forEach((word, i) => {
        const span = document.createElement('span');
        span.className = 'blur-word';
        span.textContent = word + (i < words.length - 1 ? '\u00A0' : '');
        span.style.transitionDelay = `${i * 60}ms`;
        el.appendChild(span);
      });
      const obs = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            $$('.blur-word', entry.target).forEach(w => w.classList.add('revealed'));
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      obs.observe(el);
    });
  }
  const philosophyP = $('.philosophy p');
  if (philosophyP && !prefersReducedMotion) {
    philosophyP.classList.add('blur-reveal-target');
    philosophyP.classList.remove('fade-in');
    initBlurTextReveal();
  }

  // =========================================================
  // SCROLL VINE — gated
  // =========================================================
  if (!prefersReducedMotion && settings.enableVine) {
    const vineSvg = $('#scroll-vine-svg');
    function buildScrollVine() {
      if (!vineSvg) return;
      const docHeight = document.documentElement.scrollHeight;
      const vw = window.innerWidth;
      vineSvg.setAttribute('viewBox', `0 0 ${vw} ${docHeight}`);
      vineSvg.style.height = `${docHeight}px`;
      vineSvg.style.width = '100%';
      vineSvg.innerHTML = '';
      function createPath(id, d) {
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.id = id;
        path.setAttribute('class', 'growing-vine-path');
        path.setAttribute('d', d);
        vineSvg.appendChild(path);
        const len = path.getTotalLength();
        path.dataset.length = len;
        path.style.strokeDasharray = len;
        path.style.strokeDashoffset = len;
      }
      const step = 110, totalSteps = Math.ceil(docHeight / step) + 1;
      let lx = vw * 0.04, ld = `M ${lx} 0 `;
      for (let i = 1; i <= totalSteps; i++) {
        const cy = i * step, py = (i - 1) * step, my = (py + cy) / 2;
        const off = (i % 2 === 0 ? 1 : -1) * (22 + Math.sin(i) * 9);
        const tx = vw * 0.04 + off;
        ld += `Q ${lx + off * 1.5} ${my}, ${tx} ${cy} `;
        lx = tx;
        if (i % 3 === 0) {
          const dir = off > 0 ? 1 : -1;
          ld += `L ${lx + 15 * dir} ${cy - 4} C ${lx + 22 * dir} ${cy + 7}, ${lx + 10 * dir} ${cy + 15}, ${lx} ${cy} `;
        }
      }
      createPath('left-vine', ld);
      let rx = vw * 0.96, rd = `M ${rx} 0 `;
      for (let i = 1; i <= totalSteps; i++) {
        const cy = i * step, py = (i - 1) * step, my = (py + cy) / 2;
        const off = (i % 2 === 0 ? -1 : 1) * (22 + Math.sin(i) * 9);
        const tx = vw * 0.96 + off;
        rd += `Q ${rx + off * 1.5} ${my}, ${tx} ${cy} `;
        rx = tx;
        if (i % 3 === 0) {
          const dir = off > 0 ? 1 : -1;
          rd += `L ${rx + 15 * dir} ${cy - 4} C ${rx + 22 * dir} ${cy + 7}, ${rx + 10 * dir} ${cy + 15}, ${rx} ${cy} `;
        }
      }
      createPath('right-vine', rd);
      animateVine();
    }
    function animateVine() {
      const scrollTop = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight <= 0 || !vineSvg) return;
      const frac = Math.min(Math.max(scrollTop / scrollHeight, 0), 1);
      $$('.growing-vine-path', vineSvg).forEach(p => {
        const len = parseFloat(p.dataset.length) || p.getTotalLength();
        p.style.strokeDashoffset = len * (1 - frac);
      });
    }
    buildScrollVine();
    window.addEventListener('resize', buildScrollVine);
    window.addEventListener('scroll', animateVine, { passive: true });
  }

  // =========================================================
  // HEADER — scroll state
  // =========================================================
  const siteHeader = $('.site-header');
  window.addEventListener('scroll', () => {
    siteHeader?.classList.toggle('scrolled', window.scrollY > 20);
  }, { passive: true });

  // =========================================================
  // DOCK NAV — active section tracking
  // =========================================================
  const dockPanel = $('#app-dock');
  if (dockPanel) {
    const dockItems = $$('.dock-item', dockPanel);
    const sectionIds = dockItems.map(item => item.dataset.section).filter(Boolean);
    const sectionEls = sectionIds.map(id => document.getElementById(id)).filter(Boolean);
    function updateDockActive() {
      const pos = window.scrollY + 130;
      let activeIdx = 0;
      sectionEls.forEach((sec, i) => { if (sec && pos >= sec.offsetTop) activeIdx = i; });
      dockItems.forEach((btn, i) => btn.classList.toggle('active', i === activeIdx));
    }
    window.addEventListener('scroll', updateDockActive, { passive: true });
    updateDockActive();
    dockItems.forEach(item => {
      item.addEventListener('click', (e) => {
        const id = item.dataset.section;
        const target = document.getElementById(id);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
      });
    });
  }

  // =========================================================
  // MOBILE NAV
  // =========================================================
  const mobileMenuBtn = $('#mobile-menu-btn');
  const mobileNavOverlay = $('#mobile-nav-overlay');
  const mobileNavClose = $('#mobile-nav-close');
  function openMobileNav() {
    mobileMenuBtn?.classList.add('open');
    mobileNavOverlay?.classList.add('open');
    mobileNavOverlay?.setAttribute('aria-hidden', 'false');
    mobileMenuBtn?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileMenuBtn?.classList.remove('open');
    mobileNavOverlay?.classList.remove('open');
    mobileNavOverlay?.setAttribute('aria-hidden', 'true');
    mobileMenuBtn?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  mobileMenuBtn?.addEventListener('click', openMobileNav);
  mobileNavClose?.addEventListener('click', closeMobileNav);
  $$('.mobile-nav-link').forEach(link => link.addEventListener('click', closeMobileNav));

  // =========================================================
  // SEARCH
  // =========================================================
  const searchToggle = $('#search-toggle');
  const searchClose = $('#search-close');
  const searchOverlay = $('#search-bar-overlay');
  const searchInput = $('#search-input');
  const predictiveResults = $('#predictive-results');
  let searchDebounce;

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('open');
      searchInput?.focus();
    });
    searchClose?.addEventListener('click', () => {
      searchOverlay.classList.remove('open');
      if (predictiveResults) predictiveResults.innerHTML = '';
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') searchOverlay.classList.remove('open');
    });
  }

  if (searchInput && predictiveResults) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchDebounce);
      const q = searchInput.value.trim();
      if (q.length < 2) { predictiveResults.innerHTML = ''; return; }
      searchDebounce = setTimeout(async () => {
        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`);
          const data = await res.json();
          const products = data.resources?.results?.products || [];
          if (products.length === 0) { predictiveResults.innerHTML = '<div class="predictive-search__empty">No results found</div>'; return; }
          predictiveResults.innerHTML = products.map(p => `
            <a href="${p.url}" class="predictive-search__item">
              ${p.image ? `<img src="${p.image}" alt="${p.title}" class="predictive-search__img" width="40" height="40" loading="lazy">` : ''}
              <div class="predictive-search__info">
                <span class="predictive-search__title">${p.title}</span>
                <span class="predictive-search__price">${p.price}</span>
              </div>
            </a>
          `).join('');
        } catch { predictiveResults.innerHTML = ''; }
      }, 300);
    });
  }

  // =========================================================
  // CART — AJAX functions
  // =========================================================
  async function getCart() {
    const res = await fetch(NF.routes?.cartJson || '/cart.js');
    return res.json();
  }

  async function updateCartCount() {
    try {
      const cart = await getCart();
      $$('.cart-count').forEach(el => { el.textContent = cart.item_count; });
      const cartStatus = $('#cart-status');
      if (cartStatus) cartStatus.innerHTML = `<span class="cart-dot"></span>Cart (<span class="cart-count">${cart.item_count}</span>)`;
      updateFreeShippingBar(cart.total_price);
    } catch (e) { console.error('Cart count update failed', e); }
  }

  function updateFreeShippingBar(totalPrice) {
    const threshold = settings.freeShippingThreshold || 7500;
    const fills = $$('.free-shipping-bar__fill');
    const texts = $$('.free-shipping-bar__text');
    const pct = Math.min((totalPrice / threshold) * 100, 100);
    fills.forEach(el => { el.style.width = pct + '%'; });
    texts.forEach(el => {
      if (totalPrice >= threshold) {
        el.textContent = '✓ You\'ve unlocked free shipping!';
        el.style.color = 'var(--c-accent)';
      } else {
        const remaining = ((threshold - totalPrice) / 100).toFixed(2);
        el.textContent = `$${remaining} away from free shipping`;
      }
    });
  }

  async function addToCart(variantId, quantity, btn) {
    if (!variantId) return;
    const origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    try {
      const res = await fetch(NF.routes?.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Could not add to cart');
      if (btn) { btn.textContent = '✓ Added!'; btn.style.cssText = 'background:var(--c-accent);border-color:var(--c-accent);color:#fff;opacity:1;'; }
      await updateCartCount();
      await renderCartDrawer();
      if (settings.cartType === 'drawer') openCartDrawer();
    } catch (err) {
      if (btn) { btn.textContent = err.message || 'Error — Try Again'; btn.style.color = 'red'; }
    } finally {
      setTimeout(() => {
        if (btn) { btn.textContent = origText; btn.removeAttribute('style'); btn.disabled = false; }
      }, 2000);
    }
  }
  window.addToCart = addToCart;

  async function changeCartItem(key, quantity) {
    await fetch(NF.routes?.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await updateCartCount();
    await renderCartDrawer();
    await renderCartPage();
  }

  async function renderCartDrawer() {
    const itemsEl = $('#cart-drawer-items');
    const subtotalEl = $('#cart-drawer-subtotal');
    if (!itemsEl) return;
    try {
      const cart = await getCart();
      updateFreeShippingBar(cart.total_price);
      if (cart.item_count === 0) {
        itemsEl.innerHTML = `<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="${NF.routes?.root || '/'}" class="cta-button" onclick="closeCartDrawer()">Shop Now</a></div>`;
        if (subtotalEl) subtotalEl.textContent = '$0.00';
        return;
      }
      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <a href="${item.url}" class="cart-item__image-wrap">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" class="cart-item__image" width="60" height="60" loading="lazy">` : ''}
          </a>
          <div class="cart-item__details">
            <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
            <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
            <div class="cart-item__qty-row">
              <div class="qty-stepper">
                <button class="qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease">−</button>
                <span class="qty-value">${item.quantity}</span>
                <button class="qty-btn" data-action="increase" data-key="${item.key}" aria-label="Increase">+</button>
              </div>
              <button class="cart-item__remove" data-key="${item.key}">Remove</button>
            </div>
          </div>
        </div>
      `).join('');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      bindCartItemEvents(itemsEl);
    } catch (e) { console.error('Cart drawer render failed', e); }
  }

  async function renderCartPage() {
    const itemsEl = $('#cart-page-items');
    if (!itemsEl) return;
    try {
      const cart = await getCart();
      updateFreeShippingBar(cart.total_price);
      const subtotalEl = $('#cart-page-subtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (cart.item_count === 0) {
        itemsEl.innerHTML = `<div class="cart-empty"><p>Your cart is empty.</p><a href="${NF.routes?.root || '/'}" class="cta-button">Shop Now</a></div>`;
        return;
      }
      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item cart-item--page" data-key="${item.key}">
          <a href="${item.url}" class="cart-item__image-wrap">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" class="cart-item__image" width="100" height="100" loading="lazy">` : ''}
          </a>
          <div class="cart-item__details">
            <div class="cart-item__top">
              <div>
                <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
                ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
              </div>
              <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
            </div>
            <div class="cart-item__bottom">
              <div class="qty-stepper">
                <button class="qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease">−</button>
                <span class="qty-value">${item.quantity}</span>
                <button class="qty-btn" data-action="increase" data-key="${item.key}" aria-label="Increase">+</button>
              </div>
              <button class="cart-item__remove" data-key="${item.key}">Remove</button>
            </div>
          </div>
        </div>
      `).join('');
      bindCartItemEvents(itemsEl);
    } catch (e) { console.error('Cart page render failed', e); }
  }

  function bindCartItemEvents(container) {
    $$('.qty-btn', container).forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const action = btn.dataset.action;
        const qtyEl = btn.closest('.qty-stepper')?.querySelector('.qty-value');
        const currentQty = parseInt(qtyEl?.textContent || '1');
        const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
        await changeCartItem(key, newQty);
      });
    });
    $$('.cart-item__remove', container).forEach(btn => {
      btn.addEventListener('click', async () => {
        await changeCartItem(btn.dataset.key, 0);
      });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // =========================================================
  // CART DRAWER OPEN / CLOSE
  // =========================================================
  const cartDrawer = $('#cart-drawer');
  const cartDrawerOverlay = $('#cart-drawer-overlay');

  window.openCartDrawer = function() {
    if (!cartDrawer) return;
    renderCartDrawer();
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawerOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeCartDrawer = function() {
    cartDrawer?.classList.remove('open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    cartDrawerOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  };

  $$('.cart-trigger').forEach(el => el.addEventListener('click', openCartDrawer));
  $('#cart-drawer-close')?.addEventListener('click', closeCartDrawer);
  cartDrawerOverlay?.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCartDrawer(); });

  // Bind initial drawer item events
  bindCartItemEvents($('#cart-drawer-items'));

  // Init cart page
  if (document.querySelector('.cart-page')) {
    renderCartPage();
    updateFreeShippingBar(parseInt(document.querySelector('[data-cart-total]')?.dataset.cartTotal || '0'));

    const discountBtn = $('#discount-apply-btn');
    const discountInput = $('#discount-input');
    if (discountBtn) {
      discountBtn.addEventListener('click', () => {
        const code = discountInput?.value.trim();
        if (code) window.location.href = `/discount/${code}`;
      });
    }

    const cartNoteInput = $('#cart-note');
    if (cartNoteInput) {
      let noteDebounce;
      cartNoteInput.addEventListener('input', () => {
        clearTimeout(noteDebounce);
        noteDebounce = setTimeout(async () => {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: cartNoteInput.value })
          });
        }, 500);
      });
    }
  }

  // Init free shipping bar
  updateCartCount();

  // =========================================================
  // ADD TO CART — product card buttons
  // =========================================================
  $$('.product-add-btn[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;
      if (btn.dataset.hasVariants === 'true' || btn.textContent.trim() === 'Choose Options') {
        window.location.href = `/products/${btn.closest('[data-product-handle]')?.dataset.productHandle || ''}`;
        return;
      }
      await addToCart(variantId, 1, btn);
    });
  });

  // =========================================================
  // PRODUCT PAGE — variant picker + gallery + sticky ATC
  // =========================================================
  if (window.productData) {
    const { variants, options } = window.productData;
    let selectedOptions = variants.find(v => v.id == window.productData.currentVariantId)?.options || [];

    function findVariant(opts) {
      return variants.find(v => v.options.every((o, i) => o === opts[i])) || null;
    }

    function updateVariantUI(variant) {
      if (!variant) return;
      const idInput = $('#variant-id-input');
      if (idInput) idInput.value = variant.id;
      const priceEl = $('#product-price');
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = `<span class="price price--sale">${formatMoney(variant.price)}</span><span class="price price--compare">${formatMoney(variant.compare_at_price)}</span>`;
        } else {
          priceEl.innerHTML = `<span class="price">${formatMoney(variant.price)}</span>`;
        }
      }
      const atcBtn = $('#product-atc-btn');
      const stickyBtn = $('#sticky-atc-btn');
      const buyNowBtn = $('#product-buy-now');
      [atcBtn, stickyBtn, buyNowBtn].forEach(btn => {
        if (!btn) return;
        btn.disabled = !variant.available;
        if (btn.id === 'product-atc-btn' || btn.id === 'sticky-atc-btn') {
          btn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        }
      });
      const stickyPrice = $('#sticky-price');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (variant.featured_image) {
        const mainImg = $('#product-main-image');
        if (mainImg) {
          mainImg.src = variant.featured_image.src;
          mainImg.alt = variant.featured_image.alt || '';
        }
      }
      history.replaceState(null, '', `?variant=${variant.id}`);
    }

    $$('.size-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        const optionIndex = parseInt(pill.dataset.optionIndex);
        const value = pill.dataset.value;
        selectedOptions[optionIndex] = value;
        $$('.size-pill', pill.closest('.variant-picker')).forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
        const variant = findVariant(selectedOptions);
        if (variant) updateVariantUI(variant);
        $$('.variant-picker').forEach((picker, i) => {
          $$('.size-pill', picker).forEach(p => {
            const testOptions = [...selectedOptions];
            testOptions[i] = p.dataset.value;
            const testVariant = findVariant(testOptions);
            p.classList.toggle('sold-out', testVariant ? !testVariant.available : true);
          });
        });
      });
    });

    const qtyInput = $('#product-qty');
    const qtyIncrease = $('#qty-increase');
    const qtyDecrease = $('#qty-decrease');
    if (qtyInput) {
      qtyIncrease?.addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value) + 1; });
      qtyDecrease?.addEventListener('click', () => { if (parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1; });
    }

    const productForm = $('#product-form');
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const variantId = parseInt($('#variant-id-input')?.value);
        const qty = parseInt(qtyInput?.value || '1');
        const btn = $('#product-atc-btn');
        await addToCart(variantId, qty, btn);
      });
    }

    const buyNowBtn = $('#product-buy-now');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', async () => {
        const variantId = parseInt($('#variant-id-input')?.value);
        const qty = parseInt(qtyInput?.value || '1');
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'Loading...';
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty })
          });
          window.location.href = '/checkout';
        } catch {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = 'Buy Now';
        }
      });
    }

    // Gallery thumbnails
    $$('.product-gallery__thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const mainImg = $('#product-main-image');
        if (mainImg) {
          mainImg.src = thumb.dataset.imageUrl;
          mainImg.alt = thumb.dataset.imageAlt;
        }
        $$('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });

    // Sticky ATC bar
    const atcBtn = $('#product-atc-btn');
    const stickyBar = $('#sticky-atc-bar');
    if (atcBtn && stickyBar) {
      const atcObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const shouldShow = !entry.isIntersecting;
          stickyBar.classList.toggle('visible', shouldShow);
          stickyBar.setAttribute('aria-hidden', !shouldShow);
        });
      }, { threshold: 0 });
      atcObserver.observe(atcBtn);
      $('#sticky-atc-btn')?.addEventListener('click', async () => {
        const variantId = parseInt($('#variant-id-input')?.value);
        const qty = parseInt(qtyInput?.value || '1');
        await addToCart(variantId, qty, $('#sticky-atc-btn'));
      });
    }

    // Size guide modal
    $('#size-guide-open')?.addEventListener('click', () => {
      const modal = $('#size-guide-modal');
      modal?.classList.add('open');
      modal?.setAttribute('aria-hidden', 'false');
    });
    $('#size-guide-close')?.addEventListener('click', () => {
      const modal = $('#size-guide-modal');
      modal?.classList.remove('open');
      modal?.setAttribute('aria-hidden', 'true');
    });
    $('#size-guide-overlay')?.addEventListener('click', () => {
      const modal = $('#size-guide-modal');
      modal?.classList.remove('open');
      modal?.setAttribute('aria-hidden', 'true');
    });
  }

  // =========================================================
  // COLLECTION PAGE — filter sidebar
  // =========================================================
  const filterToggle = $('#filter-toggle');
  const filterSidebar = $('#filter-sidebar');
  const filterClose = $('#filter-close');
  if (filterToggle && filterSidebar) {
    filterToggle.addEventListener('click', () => {
      const isOpen = filterSidebar.classList.toggle('open');
      filterSidebar.setAttribute('aria-hidden', !isOpen);
      filterToggle.setAttribute('aria-expanded', isOpen);
    });
    filterClose?.addEventListener('click', () => {
      filterSidebar.classList.remove('open');
      filterSidebar.setAttribute('aria-hidden', 'true');
      filterToggle.setAttribute('aria-expanded', 'false');
    });
  }

  // =========================================================
  // COPY LINK BUTTON
  // =========================================================
  const copyLinkBtn = $('#copy-link-btn');
  if (copyLinkBtn) {
    copyLinkBtn.addEventListener('click', async () => {
      const url = copyLinkBtn.dataset.url || window.location.href;
      try {
        await navigator.clipboard.writeText(url);
        const orig = copyLinkBtn.innerHTML;
        copyLinkBtn.innerHTML = '✓';
        setTimeout(() => { copyLinkBtn.innerHTML = orig; }, 2000);
      } catch { console.warn('Copy failed'); }
    });
  }

  // =========================================================
  // ANIMATED STAT COUNTERS
  // =========================================================
  function animateCounter(el, target, dur = 1800) {
    if (prefersReducedMotion) { el.textContent = target + (el.dataset.suffix || ''); return; }
    const suffix = el.dataset.suffix || '';
    const isFloat = target % 1 !== 0;
    const start = performance.now();
    const tick = (now) => {
      const prog = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - prog, 3);
      el.textContent = (isFloat ? (eased * target).toFixed(1) : Math.round(eased * target)) + suffix;
      if (prog < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
  const statObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const t = parseFloat(entry.target.dataset.target);
        if (!isNaN(t)) animateCounter(entry.target, t);
        statObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });
  $$('.stat-number[data-target]').forEach(el => statObserver.observe(el));

  // =========================================================
  // MAGNETIC HERO CTA
  // =========================================================
  const heroCta = $('#hero-cta');
  if (heroCta && !prefersReducedMotion) {
    heroCta.addEventListener('mousemove', (e) => {
      const rect = heroCta.getBoundingClientRect();
      const mx = e.clientX - rect.left, my = e.clientY - rect.top;
      heroCta.style.setProperty('--mx', `${mx}px`);
      heroCta.style.setProperty('--my', `${my}px`);
      heroCta.style.transform = `translate(${(mx - rect.width / 2) * 0.14}px, ${(my - rect.height / 2) * 0.14}px)`;
    });
    heroCta.addEventListener('mouseleave', () => { heroCta.style.transform = 'translate(0, 0)'; });
  }

  // =========================================================
  // SCROLL FLOAT — GSAP per-character entrance
  // =========================================================
  if (!prefersReducedMotion && typeof gsap !== 'undefined') {
    function initScrollFloat() {
      $$('.scroll-float').forEach(el => {
        const text = el.innerText.trim();
        el.innerHTML = '';
        const words = text.split(' ');
        words.forEach((word, wi) => {
          const wSpan = document.createElement('span');
          wSpan.style.cssText = 'display:inline-block; white-space:nowrap;';
          [...word].forEach(ch => {
            const s = document.createElement('span');
            s.className = 'char';
            s.textContent = ch;
            wSpan.appendChild(s);
          });
          el.appendChild(wSpan);
          if (wi < words.length - 1) {
            const sp = document.createElement('span');
            sp.textContent = '\u00A0';
            sp.style.display = 'inline-block';
            el.appendChild(sp);
          }
        });
        const chars = $$('.char', el);
        chars.forEach((c, idx) => c.style.setProperty('--char-index', idx));
        const isHero = el.id === 'hero-title';
        if (isHero) {
          gsap.set(chars, { opacity: 1, y: 0, scaleY: 1, scaleX: 1 });
          gsap.fromTo(chars,
            { opacity: 0, y: 70, scaleY: 2.0, scaleX: 0.8, transformOrigin: '50% 0%' },
            { opacity: 1, y: 0, scaleY: 1, scaleX: 1, duration: 1.3, ease: 'power4.out', stagger: 0.04, delay: 0.25,
              onComplete: () => {
                gsap.set(chars, { clearProps: 'all' });
                gsap.to(chars, {
                  scrollTrigger: { trigger: '.hero', start: 'center top', end: 'bottom top', scrub: 1.5 },
                  opacity: 0.12, y: -60, stagger: 0.015, ease: 'none'
                });
              }
            }
          );
        } else {
          gsap.fromTo(chars,
            { opacity: 0, yPercent: 130, scaleY: 2.5, scaleX: 0.65, transformOrigin: '50% 0%' },
            { opacity: 1, yPercent: 0, scaleY: 1, scaleX: 1, duration: 1, ease: 'back.out(2)', stagger: 0.028,
              scrollTrigger: { trigger: el, start: 'center bottom+=35%', end: 'bottom center+=15%', scrub: 1.0 }
            }
          );
        }
      });
    }
    initScrollFloat();
  }

  // =========================================================
  // BOUNCECARD LOOKBOOK — responsive, from data-images attr
  // =========================================================
  const lookbookContainer = $('#lookbook-bounce-cards');
  if (lookbookContainer) {
    let imagesAttr = lookbookContainer.dataset.images;
    let altsAttr = lookbookContainer.dataset.alts;
    let images = [], alts = [];
    try {
      if (imagesAttr && imagesAttr !== '[]') { images = JSON.parse(imagesAttr); alts = JSON.parse(altsAttr || '[]'); }
    } catch (e) {}
    if (images.length === 0) {
      images = [
        'stage_1_fracture_1777923390459.png','stage_2_rooted_1777923973219.png',
        'stage_3_ascent_1777924282266.png','stage_4_bloom_1777924294569.png',
        'stage_5_full_bloom_1777924801842.png'
      ].map(f => `/cdn/shop/files/${f}`);
    }
    const transforms = [
      'rotate(13deg) translate(-210px, 8px)','rotate(6deg) translate(-105px, -6px)',
      'rotate(-2deg) translate(0px, -14px)','rotate(-8deg) translate(105px, -6px)',
      'rotate(5deg) translate(210px, 8px)'
    ];
    function setLookbookSize() {
      const vw = window.innerWidth;
      if (vw < 600) {
        lookbookContainer.style.width = '100%';
        lookbookContainer.style.height = 'auto';
        lookbookContainer.style.flexDirection = 'column';
        $$('.card', lookbookContainer).forEach(c => {
          c.style.position = 'relative';
          c.style.transform = 'none';
          c.style.margin = '0 auto 1rem';
          c.style.width = '80%';
        });
      } else if (vw < 1024) {
        lookbookContainer.style.width = '600px';
        lookbookContainer.style.height = '360px';
      } else {
        lookbookContainer.style.width = '920px';
        lookbookContainer.style.height = '400px';
      }
    }
    images.forEach((src, idx) => {
      const card = document.createElement('div');
      card.className = `card card-${idx}`;
      card.style.transform = transforms[idx] || 'none';
      const img = document.createElement('img');
      img.className = 'image';
      img.src = src;
      img.alt = alts[idx] || `Lookbook image ${idx + 1}`;
      img.loading = 'lazy';
      card.appendChild(img);
      lookbookContainer.appendChild(card);
    });
    setLookbookSize();
    window.addEventListener('resize', setLookbookSize);
    if (!prefersReducedMotion && typeof gsap !== 'undefined') {
      gsap.fromTo('#lookbook-bounce-cards .card',
        { scale: 0, opacity: 0 },
        { scale: 1, opacity: 1, stagger: 0.09, ease: 'elastic.out(1, 0.6)', duration: 1.4,
          scrollTrigger: { trigger: '#lookbook-bounce-cards', start: 'top 80%', once: true }
        }
      );
      function getNoRotate(t) { return /rotate\(/.test(t) ? t.replace(/rotate\([^)]+\)/, 'rotate(0deg)') : `rotate(0deg)`; }
      function getPushed(t, ox) {
        const m = t.match(/translate\(([-\d.]+)px,\s*([-\d.]+)px\)/);
        return m ? t.replace(m[0], `translate(${parseFloat(m[1]) + ox}px, ${m[2]}px)`) : `${t} translate(${ox}px)`;
      }
      $$('.card', lookbookContainer).forEach((card, hIdx) => {
        card.addEventListener('mouseenter', () => {
          if (window.innerWidth < 600) return;
          $$('.card', lookbookContainer).forEach((el, i) => {
            gsap.killTweensOf(el);
            const base = transforms[i] || 'none';
            if (i === hIdx) {
              gsap.to(el, { transform: getNoRotate(base), scale: 1.06, duration: 0.4, ease: 'back.out(1.5)', overwrite: 'auto' });
            } else {
              const offset = i < hIdx ? -145 : 145;
              gsap.to(el, { transform: getPushed(base, offset), scale: 0.94, duration: 0.4, ease: 'back.out(1.5)', delay: Math.abs(hIdx - i) * 0.04, overwrite: 'auto' });
            }
          });
        });
        card.addEventListener('mouseleave', () => {
          if (window.innerWidth < 600) return;
          $$('.card', lookbookContainer).forEach((el, i) => {
            gsap.killTweensOf(el);
            gsap.to(el, { transform: transforms[i] || 'none', scale: 1, duration: 0.45, ease: 'back.out(1.4)', overwrite: 'auto' });
          });
        });
      });
    }
  }

  // =========================================================
  // TILTED CARD 3D PARALLAX
  // =========================================================
  if (!prefersReducedMotion && typeof gsap !== 'undefined') {
    $$('.tilted-card-figure').forEach(card => {
      const inner = $('.tilted-card-inner', card);
      const caption = $('.tilted-card-caption', card);
      if (!inner) return;
      const amp = 14, scale = 1.05;
      let rect;
      const refreshRect = () => { rect = card.getBoundingClientRect(); };
      card.addEventListener('mouseenter', () => { refreshRect(); gsap.to(inner, { scale, duration: 0.4, ease: 'power2.out' }); if (caption) gsap.to(caption, { opacity: 1, duration: 0.2 }); });
      card.addEventListener('mousemove', (e) => {
        if (!rect) refreshRect();
        const ox = e.clientX - rect.left - rect.width / 2;
        const oy = e.clientY - rect.top - rect.height / 2;
        gsap.to(inner, { rotateY: (ox / (rect.width / 2)) * amp, rotateX: -(oy / (rect.height / 2)) * amp, duration: 0.12, ease: 'power1.out', overwrite: 'auto' });
        if (caption) { caption.style.left = `${e.clientX - rect.left}px`; caption.style.top = `${e.clientY - rect.top - 22}px`; }
      });
      card.addEventListener('mouseleave', () => { gsap.to(inner, { rotateX: 0, rotateY: 0, scale: 1, duration: 0.6, ease: 'power2.out', overwrite: 'auto' }); if (caption) gsap.to(caption, { opacity: 0, duration: 0.25 }); });
      window.addEventListener('resize', refreshRect);
    });
  }

  // =========================================================
  // SPOTLIGHT CARD
  // =========================================================
  $$('.card-spotlight').forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      card.style.setProperty('--mouse-x', `${e.clientX - rect.left}px`);
      card.style.setProperty('--mouse-y', `${e.clientY - rect.top}px`);
    });
  });

  // =========================================================
  // CLICK SPARK — gated
  // =========================================================
  if (!prefersReducedMotion && settings.enableSparks) {
    const canvas = $('#click-spark-canvas');
    if (canvas) {
      const ctx = canvas.getContext('2d');
      let sparks = [];
      const SPARK_COLOR = '#C9A46C', SPARK_COUNT = 9, SPARK_RADIUS = 22, SPARK_SIZE = 12, DURATION = 480;
      const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
      window.addEventListener('resize', resize); resize();
      const easeOut = t => t * (2 - t);
      document.addEventListener('click', (e) => {
        const now = performance.now();
        for (let i = 0; i < SPARK_COUNT; i++) sparks.push({ x: e.clientX, y: e.clientY, angle: (2 * Math.PI * i) / SPARK_COUNT, startTime: now });
      });
      (function draw(ts = 0) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        sparks = sparks.filter(s => {
          const el = ts - s.startTime;
          if (el >= DURATION) return false;
          const prog = el / DURATION, eased = easeOut(prog);
          const dist = eased * SPARK_RADIUS, len = SPARK_SIZE * (1 - eased);
          const x1 = s.x + dist * Math.cos(s.angle), y1 = s.y + dist * Math.sin(s.angle);
          const x2 = s.x + (dist + len) * Math.cos(s.angle), y2 = s.y + (dist + len) * Math.sin(s.angle);
          ctx.strokeStyle = SPARK_COLOR; ctx.globalAlpha = 1 - eased; ctx.lineWidth = 2;
          ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
          ctx.globalAlpha = 1;
          return true;
        });
        requestAnimationFrame(draw);
      })();
    }
  }

  // =========================================================
  // HERO PARTICLES — gated
  // =========================================================
  if (!prefersReducedMotion && settings.enableParticles) {
    const canvas = $('#hero-particles-canvas');
    if (canvas) {
      const ctx = canvas.getContext('2d');
      let particles = [];
      const PARTICLE_COUNT = 35;
      const resize = () => { const rect = canvas.parentElement.getBoundingClientRect(); canvas.width = rect.width; canvas.height = rect.height; };
      window.addEventListener('resize', resize); resize();
      for (let i = 0; i < PARTICLE_COUNT; i++) {
        particles.push({ x: Math.random() * canvas.width, y: Math.random() * canvas.height, radius: Math.random() * 1.8 + 0.6, speedX: (Math.random() - 0.5) * 0.25, speedY: -Math.random() * 0.35 - 0.1, alpha: Math.random() * 0.4 + 0.1, color: Math.random() > 0.4 ? '#C9A46C' : '#7A9068' });
      }
      function draw() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach(p => {
          p.x += p.speedX; p.y += p.speedY;
          if (p.x < 0) p.x = canvas.width;
          if (p.x > canvas.width) p.x = 0;
          if (p.y < 0) { p.y = canvas.height; p.x = Math.random() * canvas.width; }
          ctx.save(); ctx.globalAlpha = p.alpha; ctx.fillStyle = p.color;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2); ctx.fill(); ctx.restore();
        });
        requestAnimationFrame(draw);
      }
      draw();
    }
  }

  // =========================================================
  // HERO LOGO PARALLAX
  // =========================================================
  const heroLogo = $('.hero-logo-img');
  if (heroLogo && !prefersReducedMotion) {
    window.addEventListener('scroll', () => {
      const pct = Math.min(window.scrollY / window.innerHeight, 1);
      heroLogo.style.transform = `translateY(${-pct * 30}px) scale(${1 - pct * 0.1})`;
      heroLogo.style.opacity = `${1 - pct * 0.8}`;
    }, { passive: true });
  }

  // =========================================================
  // SMOOTH SCROLL for anchor links
  // =========================================================
  $$('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href').slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  // =========================================================
  // MARQUEE — dynamic speed from CSS variable
  // =========================================================
  const marqueeTrack = $('.marquee-track');
  if (marqueeTrack && marqueeTrack.style.animationDuration) {
    marqueeTrack.style.setProperty('animation-duration', marqueeTrack.style.animationDuration);
  }

  // =========================================================
  // QUANTITY STEPPER (generic — for cart page)
  // =========================================================
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty-btn[data-key]');
    if (!btn) return;
    const key = btn.dataset.key;
    const action = btn.dataset.action;
    const qtyEl = btn.closest('.qty-stepper')?.querySelector('.qty-value');
    const current = parseInt(qtyEl?.textContent || '1');
    const newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);
    if (qtyEl) qtyEl.textContent = newQty;
    changeCartItem(key, newQty);
  });

  console.log('%cNext Form v4.0 — Fully loaded.', 'color:#C9A46C;font-family:Cinzel,serif;font-size:14px;');
});
